import HTTPClient from '@elab/core/utils/HTTPClient';
import cartApi from '@elab/core/store/cart/api';

const getDeliveryMode = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/deliverymode`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(
            `Unable to get ... store/checkout/api.js --> getDeliveryMode(): (${response})`,
        );
    }
    return await response.json();
};

const loadDeliveryModes = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/deliverymodes`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to get delivery modes (${response.status})`);
    }
    return await response.json();
};

const setDeliveryMode = async (
    userId,
    cartId,
    deliveryModeId,
    selectedStore,
    deliveryTime,
    currentCountry,
    shouldSendStoreId,
) => {
    let uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
    )}/deliverymode?deliveryModeId=${deliveryModeId}`;

    if ((shouldSendStoreId || deliveryModeId.toLowerCase().includes('pickup')) && selectedStore) {
        uri = uri.concat(`&storeId=${selectedStore}`);
    }
    if (deliveryTime) {
        uri = uri.concat(`&deliverySlot=${deliveryTime}`);
    }
    if (currentCountry) {
        uri = uri.concat(`&country=${currentCountry}`);
    }
    const response = await HTTPClient().putJson(uri);
    if (!response.ok) {
        throw new Error(`Unable to set email (${response.status})`);
    }
    return response;
};

export default {
    getDeliveryMode,
    loadDeliveryModes,
    setDeliveryMode,
};
